// extracted by mini-css-extract-plugin
export var arrows = "_93-6";
export var decrementer = "_93-a";
export var disabled = "_93-4";
export var error = "_93-1";
export var hiddenText = "_93-b";
export var incrementer = "_93-9";
export var input = "_93-8";
export var inputWrapper = "_93-0";
export var leadingIcon = "_93-c";
export var readonly = "_93-3";
export var regular = "_93-7";
export var small = "_93-5";
export var warning = "_93-2";